import React, { Component } from 'react';
import ReactSelect from "react-select";
import _, { isEmpty, get } from 'lodash';
import MySelect from "../../../../../../components/CheckboxSelect";
import { getFacebookUserInfoAction, syncAccCampaignAction, facebookSyncCampaignAction, createAdvertiserAction, getFacebookRefetchAction, deleteAccountsAction } from "../../../../../../actions"
import { connect } from 'react-redux';
import ToastModal from "../../../../../../components/ToastModal";
import routes from "../../../../../../routes";
import FacebookLogin from 'react-facebook-login';
import Input from "../../../../../../components/FormElements/Input";
import { facebookFormFields } from "./constant";


class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      facebookAds: [{ optionSelected: [], status: false, syncAccPayload: {}, sync: false, campaignToggle: false, masterAccountToogle: false, accToggle: false, fetchInfo: [], fetchCampaignInfo: [], enableCurency: false, fbAccountID: "", fbCurrency: "", campaignSelected: [],isInfomo:0 }],
      masterAccountToogle: false,
      accToggle: false,
      campaignToggle: false,
      fetchInfo: [],
      syncAccPayload: {},
      fetchCampaignInfo: [],
      campaignsPayload: {},
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      createAdvertiserPayload: {},
      cardStatus: false,
      redirectToList: false,
      isReloadPage: false
    }
  }

  async componentWillMount() {
    const { editId } = this.props;

    await this.editId(editId)
  }

  editId = async (editId) => {
    const { facebookEditData } = this.props;

    // console.log("facebookEditData", facebookEditData, editId);

    if (editId) {
      let facebookData = facebookEditData.map(item => {
        return {
          fbAccountID: item.accountId,
          fbCurrency: item.currency,
          optionSelected: [],
          status: false,
          sync: true,
          campaignToggle: false,
          masterAccountToogle: false,
          accToggle: false,
          fetchInfo: [],
          fetchCampaignInfo: [],
          enableCurency: false,
          accountIdForDelete: -1,
          indexForDelete: -1,
          isInfomo:item.isInfomo == 1 ? 1 : 0,
          accountName:item.accountName ? item.accountName : ""
        }
      })

      // console.log("facebook data", facebookData);

      this.setState({ facebookAds: facebookData });
    }
  }

  getUserInformation = async (accessToken) => {
    const { getFacebookUserInfoAction, facebookEditData = [] } = this.props;
    const { facebookAds } = this.state;
    const { responseCode: { status = "", msg = '' }, response } = await getFacebookUserInfoAction({ accessToken });
    // console.log(facebookAds);
    if (status == "Success") {
      let data = response.adAccounts.map((item, index) => {
        let obj = { id: response.id, name: response.name, email: response.email, value: item.name, label: item.name, currency: item.currency, accId: item.id, isExist: item.isExist, accessToken: response.accessToken };
        let findAlreadyExistData = facebookEditData.find((dataExist) => dataExist.accountId == item.id);
        if (findAlreadyExistData) {
          obj["isdisabled"] = true;
        }
        return obj;
      })


      facebookAds.forEach((i, index) => {
        facebookAds[index].status = true;
        facebookAds[index].fetchInfo = data;
        // facebookAds[index].masterAccountToogle = true;
      })

      this.setState({ facebookAds, masterAccountToogle: true })
    }
    else if (status.toLowerCase() == "fail") {
      let toastStatus = "error";
      let msgStr = msg && msg.length > 0 ? msg : 'Something went wrong';
      this.toast(toastStatus, msgStr, true);
    }
  }

  handleCloseBtn = index => {
    const { facebookAds } = this.state;
    const list = [...facebookAds];
    list.splice(index, 1);
    this.setState({ facebookAds: list });
  };

  // ========== Remove Facebook Ads Account ========
  handleRemoveClick = async (index, accountId) => {
    // console.log("accountId", accountId);

    this.setState({ isReloadPage: true, enableToast: true, accountIdForDelete: accountId, indexForDelete: index, toastStatus: "confirmation", confirmationMsg: 'Kindly confirm the deletion of this record. This action cannot be undone.' });
  };

  handleAddClick = () => {
    this.setState({ facebookAds: [...this.state.facebookAds, { optionSelected: [], status: false, syncAccPayload: {}, campaignSelected: [], campaignToggle: false, masterAccountToogle: false, accToggle: false, fetchInfo: [], fetchCampaignInfo: [],isInfomo:0 }] });
  };

  toggle = (event, index, facebook) => {
    const { id } = event.target;
    if (id == "master-account") {
      this.handleAccAndGetCampaign(index, facebook);
    } else if (id == "exit-screen") {
      this.setState({ masterAccountToogle: false, accToggle: false, campaignToggle: false })
    } else {
      this.setState({ masterAccountToogle: false, accToggle: false, campaignToggle: false })
    }
  }

  // ========== onChange ========
  handleSelectChange = (selected, index, name) => {
    // console.log(selected);
    let advertiserId = JSON.parse(localStorage.getItem("advertiserId"))
    const { facebookAds } = this.state;

    if (name === "accountAds") {
      var createAdvertiser = []
      var syncAcc = [];
      let obj = {
        id: selected.id,
        name: selected.name,
        email: selected.email,
        adAccounts: syncAcc,
        accessToken: selected.accessToken
      }

      let selectedAcc = {
        id: selected.accId,
        name: selected.value,
        currency: selected.currency,
        isExist: selected.isExist
      }

      syncAcc.push(selectedAcc);


      // ======= create advetiser payload =======
      let createObj = {
        accountId: selected.accId,
        currency: selected.currency,
        inex: 1
      }

      createAdvertiser.push(createObj);

      let advertiserPayload = {
        advertisersPlatforms: [{
          advertiser: advertiserId,
          inex: 1,
          platforms: createAdvertiser
        }]
      }

      facebookAds[index].optionSelected = selected;
      facebookAds[index].syncAccPayload = obj;
      this.setState({ facebookAds, syncAccPayload: obj, createAdvertiserPayload: advertiserPayload });

    } else if (name === "campaigns") {

      let campaignsPayload = {
        accountCampaignList: []
      }

      let changeSelectedData = selected.map(sel => {
        return {
          id: sel.id,
          name: sel.value,
          budget_rebalance_flag: sel.budget_rebalance_flag,
          is_skadnetwork_attribution: sel.is_skadnetwork_attribution,
          status: sel.status
        }
      })
      if (selected.length > 0) {
        let seletedCampaigns = {
          accountId: selected[0].accountId,
          campaignList: changeSelectedData
        };
        facebookAds[index].campaignSelected = selected;
        campaignsPayload.accountCampaignList.push(seletedCampaigns);

        // ======= data

        this.setState({ campaignsPayload: campaignsPayload, facebookAds })

      }
      else {
        facebookAds[index].campaignSelected = [];
        this.setState({ campaignsPayload: {}, facebookAds })
      }
    }

    else {
      let campaignsPayload = {
        accountCampaignList: []
      }

      let changeSelectedData = selected.map(sel => {
        return {
          id: sel.id,
          name: sel.value,
          budget_rebalance_flag: sel.budget_rebalance_flag,
          is_skadnetwork_attribution: sel.is_skadnetwork_attribution,
          status: sel.status
        }
      })

      if (selected.length > 0) {
        let seletedCampaigns = {
          accountId: selected[0].accountId,
          campaignList: changeSelectedData
        };

        facebookAds[index].campaignSelected = selected;
        campaignsPayload.accountCampaignList.push(seletedCampaigns);

        // ======= data
        this.setState({ campaignsPayload: campaignsPayload, facebookAds })
      }
      else {
        facebookAds[index].campaignSelected = [];
        this.setState({ campaignsPayload: {}, facebookAds })
      }
    }
  };

  // ========= sync account and get campaign list ========= 
  handleAccAndGetCampaign = async (index, item) => {
    const { tenantId, userId, syncAccCampaignAction } = this.props;
    const { syncAccPayload, facebookAds } = this.state;


    let clonedFacebookData = _.cloneDeep(facebookAds[index]);

    // console.log("syncAccPayload", syncAccPayload);
    // console.log("item", item);
    // console.log(syncAccPayload,facebookAds[index])
    // return;
    if (clonedFacebookData.syncAccPayload && Object.keys(clonedFacebookData.syncAccPayload).length > 0) {
      let payloadForCampaignFetch = clonedFacebookData.syncAccPayload;
      payloadForCampaignFetch["accountName"] = facebookAds[index].optionSelected && facebookAds[index].optionSelected.value ? facebookAds[index].optionSelected.value:"" 
      const { responseCode: { status = "" }, response } = await syncAccCampaignAction({ tenantId, userId, payload: payloadForCampaignFetch });

      if (status === "Success") {
        var data = response.accountCampaignList[0].campaignList.map((el => {
          return {
            id: el.id,
            status: el.status,
            value: el.id,
            label: el.name,
            budget_rebalance_flag: el.budget_rebalance_flag,
            is_skadnetwork_attribution: el.is_skadnetwork_attribution, accountId: response.accountCampaignList[0].accountId,
            start_time:el.start_time ? el.start_time :"",
            stop_time:el.stop_time ? el.stop_time :""
          }
        }))


        facebookAds[index].campaignToggle = true;
        facebookAds[index].fetchCampaignInfo = data;
        facebookAds[index].accToggle = true;
        facebookAds[index].enableCurency = true;
        // facebookAds[index].fbAccountID = facebook.optionSelected.accountId;
        // facebookAds[index].fbCurrency = facebook.optionSelected.currency;

        this.setState({ facebookAds })
      }
    }
    else {
      let toastStatus = "required";
      let msg = "Please Select A Account.";
      this.toast(toastStatus, msg, true);
    }
  }

  // ==== sync campaign =====
  // handleSyncCampaign = async () => {
  //   console.log("iiiiii");
  //   const { campaignsPayload, facebookAds } = this.state;
  //   const { facebookSyncCampaignAction, tenantId, userId, handleCallback } = this.props;

  //   const { responseCode: { status = "", msg = "" } } = await facebookSyncCampaignAction({ tenantId, userId, payload: campaignsPayload })

  //   if (status) {
  //     handleCallback(facebookAds, "login")
  //     this.setState(({redirectToList:true}),()=>{
  //       this.toast(status, msg)
  //     })
  //   }
  // }


  handleSyncCampaign = async (index) => {
    const { campaignsPayload, facebookAds } = this.state;
    const { facebookSyncCampaignAction, tenantId, userId, handleCallback } = this.props;

    let campaignsPayloadGenerate = {
      accountCampaignList: []
    }

    let clonedDataFacebook = _.cloneDeep(facebookAds);
    if (clonedDataFacebook[index] && clonedDataFacebook[index].campaignSelected) {

      let changeSelectedData = clonedDataFacebook[index].campaignSelected.map(sel => {
        return {
          id: sel.id,
          name: sel.label,
          budget_rebalance_flag: sel.budget_rebalance_flag,
          is_skadnetwork_attribution: sel.is_skadnetwork_attribution,
          status: sel.status,
          accountId: sel.accountId,
          start_time:sel.start_time ? sel.start_time :"",
          stop_time:sel.stop_time ? sel.stop_time :""
        }
      });

      if (changeSelectedData.length > 0) {
        let seletedCampaigns = {
          accountId: changeSelectedData[0].accountId,
          campaignList: changeSelectedData
        };


        campaignsPayloadGenerate.accountCampaignList.push(seletedCampaigns);
      }

      if (campaignsPayloadGenerate && campaignsPayloadGenerate.accountCampaignList && campaignsPayloadGenerate.accountCampaignList.length > 0) {
        const { responseCode: { status = "", msg = "" } } = await facebookSyncCampaignAction({ tenantId, userId, payload: campaignsPayloadGenerate })

        if (status) {
          handleCallback(facebookAds, "login");
          this.setState(({ redirectToList: true }), () => {
            this.toast(status, msg);
          })
        }
      }
      else {
        let toastStatus = "required";
        let msg = "Please select a campaign.";
        this.toast(toastStatus, msg, true);
      }
    }
  }

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  deleteRecord = async () => {
    const { tenantId, authToken, userId, deleteAccountsAction } = this.props;
    const { accountIdForDelete, indexForDelete } = this.state;
    // console.log(accountIdForDelete, indexForDelete);
    const { responseCode: { status = "", msg = "" }, responseList } = await deleteAccountsAction({ tenantId, authToken, userId, accountId: accountIdForDelete });
    if (status == "Success") {
      // console.log("Deleted- accountId", accountIdForDelete);
      const { facebookAds } = this.state;
      const list = [...facebookAds];
      list.splice(indexForDelete, 1);
      this.setState({ facebookAds: list, isReloadPage: false });

      window.location.reload();

    }
    else if (status.toLowerCase() == 'fail') {
      let toastStatus = "error";
      let msgStr = msg && msg.length > 0 ? msg : 'Something went wrong';
      this.toast(toastStatus, msgStr, true);
    }
  }

  confirmationCallbackModel = (id) => {
    // console.log('hello2')
    const { facebookAds, isReloadPage, redirectToList } = this.state;
    const { handleCallback, history } = this.props;
    this.setState({ enableToast: false }, () => {
      // console.log(isReloadPage);
      if (isReloadPage) {
        this.deleteRecord();
      }
      else if (redirectToList) {
        // console.log(history);
        history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
      }
      handleCallback(facebookAds, "login")
    });
  }

  handleToastStatus = (status) => {
    // console.log('hello')
    const { facebookAds, redirectToList, isReloadPage } = this.state;
    const { handleCallback, history } = this.props;
    // console.log(isReloadPage);
    // console.log(toastMsg);
    this.setState({ enableToast: status }, () => {
      // console.log(isReloadPage);
      if (redirectToList) {
        // console.log(history);
        history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
      }
      handleCallback(facebookAds, "login")
    });
  }

  createAdvertiser = async () => {
    const { tenantId, authToken, userId, createAdvertiserAction, history, match } =
      this.props;
    const { createAdvertiserPayload } = this.state;

    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await createAdvertiserAction({
      tenantId,
      authToken,
      userId,
      payload: createAdvertiserPayload,
    });

    if (status) {
      this.toast(status, msg);
    }
  }

  // ========= handle facebook access token  =========
  responseFacebook = async (response) => {
    const { accessToken } = response;
    await this.getUserInformation(accessToken);
  }

  handleResync = async (item, index) => {
    const {
      facebookAds
    } = this.state;
    // console.log("item", item);

    let accountId = item.fbAccountID;
    const { getFacebookRefetchAction, tenantId, userId, authToken } = this.props;
    const { responseCode: { status = "", msg = "" }, response: { accountCampaignList } } = await getFacebookRefetchAction({ tenantId, userId, authToken, accountId });

    if (status == "Success") {
      const campaignList = accountCampaignList[0].campaignList.map(item => {
        return {
          id: item.id,
          label: item.name,
          value: item.id,
          status: item.status,
          isExist: item.isExist,
          accountId: accountCampaignList[0].accountId,
          budget_rebalance_flag: item.budget_rebalance_flag,
          is_skadnetwork_attribution: item.is_skadnetwork_attribution,
          start_time:item.start_time ? item.start_time :"",
          stop_time:item.stop_time ? item.stop_time :""
        }
      })

      facebookAds[index].campaignToggle = true;
      facebookAds[index].campaignSelected = campaignList.filter((dataFilter) => dataFilter.isExist == 1);
      facebookAds[index].campaignDetails = campaignList;

      this.setState({ facebookAds })
    }
    else if (status.toLowerCase() == "fail") {
      let toastStatus = "error";
      let msgStr = msg && msg.length > 0 ? msg : 'Something went wrong';
      this.toast(toastStatus, msgStr, true);
    }

  }

  render() {
    const { accountOptions, options, onChange, value, masterAccToogle, paths } = this.props;
    const { facebookAds, accToggle, campaignToggle, masterAccountToogle, fetchInfo, fetchCampaignInfo, enableToast, toastStatus, toastMsg, confirmationMsg, cardStatus } = this.state;
    let Option = options.optionFun;
    let multiValue = options.multiValue;
    // console.log("facebookAds", facebookAds);
    return (
      <>
        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            // path={routes.containers.admin + "/" + routes.admin.advertiser.poc}
            idProps={paths}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            outSideClickEnable={false}
            poc={true}
          />
        }

        {
          <div className='col-md-8 offset-md-2'>
            {
              facebookAds.map((facebook, index) => (
                !facebook.sync ?
                  facebook.status ?
                    <div className={`mb-4 mainCard ${facebook.status ? "text-left" : ""}`} key={index}>
                      <div className='col-md-11' style={{ padding: "25px" }}>
                        <h5 className='text-left'>Facebook Account </h5>
                        {
                          (masterAccountToogle) ?
                            <>
                              <h5>Select Master Account :</h5>
                              <div className='platform'>
                                <ReactSelect
                                  options={facebook.fetchInfo}
                                  defaultValue={facebook.optionSelected}
                                  className="selectBox"
                                  onChange={(selected) => this.handleSelectChange(selected, index, "accountAds")}
                                  isOptionDisabled={(option) => option.isdisabled}
                                  isDisabled = {facebook.accToggle}
                                // isDisabled={masterDisabled}
                                />
                                {
                                  !facebook.accToggle &&
                                  <div className='syncCampagin text-right'>
                                    <button style={{ width: 150 }} className='btn-add' id='master-account' onClick={(e) => this.toggle(e, index, facebook)}>Fetch Campaign</button>
                                  </div>
                                }
                              </div>
                            </> : ""
                        }

                        {
                          facebook.enableCurency ?
                            <div classname="platform" style={{ margin: "15px 0px 15px 0px" }}>
                              <label class="d-block">Currency</label>
                              <input disabled value={facebook.optionSelected.currency.replaceAll('"', '')} classname="input-disabled" class="w-100 p-1" />
                            </div> : ""
                        }

                        {
                          facebook.campaignToggle ?
                            <>
                              <h5>Synced Campaign list :</h5>
                              <div className='platform'>
                                <MySelect
                                  options={facebook.fetchCampaignInfo}
                                  isMulti
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  components={{ Option, multiValue }}
                                  onChange={(selected) => this.handleSelectChange(selected, index, "campaigns")}
                                  allowSelectAll={true}
                                  value={facebook.campaignSelected}
                                  className="selectBox"
                                />
                                <div className='syncCampagin text-right'>
                                  <button style={{ width: 150 }} className='btn-add' id='exit-screen' onClick={() => this.handleSyncCampaign(index)}>Sync Campaign</button>
                                </div>
                              </div>
                            </> : ""
                          // <button className="btnSync"><i className='mdi mdi-sync'></i></button>
                        }
                      </div>
                    </div>
                    :
                    <div className='col-md-12 loginBtnList mt-3 '>
                      <p>Login With Facebook Account :</p>
                      <FacebookLogin
                        appId="1122721198495372"
                        // autoLoad={true}
                        scope="email,read_insights,publish_video,pages_show_list,ads_management,ads_read,business_management,pages_messaging,leads_retrieval,attribution_read,pages_read_engagement,pages_read_user_content,pages_manage_engagement,public_profile"
                        fields="name,email,picture"
                        textButton='Login With Facebook'
                        cssClass="loginBtn loginBtn--facebook"
                        isDisabled={false}
                        callback={this.responseFacebook}
                      />
                      <button className="btn-delete" onClick={() => this.handleCloseBtn(index)}><i className='mdi mdi-close'></i></button>
                    </div>
                  :
                  <>
                    {
                      facebook.isInfomo == 0 ?
                        <div className='col-md-12 mb-4 p-3 manualCard' key={index}>
                          <div className=''>
                            <h5 className="text-dark">Facebook Account :</h5>

                            <div className='pointerEventNone'>
                              <Input
                                onChange={(e) => { }}
                                onBlur={(e) => { }}
                                value={`${facebook.accountName ? facebook.accountName +" "+'(' + facebook.fbAccountID + ')' : facebook.fbAccountID}`}
                                setting={facebookFormFields[facebookFormFields.fbAccountID.key]}
                              // error={facebookList.errors[facebookFormFields.fbAccountID.key]}
                              // submited={submited}
                              // touched={facebookList.touched[facebookFormFields.fbAccountID.key]}
                              />
                            </div>
                            <div className='removeML pointerEventNone'>
                              <Input
                                onChange={(e) => { }}
                                onBlur={(e) => { }}
                                value={facebook.fbCurrency}
                                setting={facebookFormFields[facebookFormFields.fbCurrency.key]}
                              // error={facebookList.errors[facebookFormFields.fbCurrency.key]}
                              // submited={submited}
                              // touched={facebookList.touched[facebookFormFields.fbCurrency.key]}
                              />


                            </div>

                            {
                              facebook.campaignToggle ?
                                <div className=''>
                                  <label class="col-sm-6 col-form-label fs-6 pl-0">Sync Campaign <span class="text-danger">*</span></label>
                                  <div className='platform d-block'>
                                    <MySelect
                                      options={facebook.campaignDetails}
                                      isMulti
                                      closeMenuOnSelect={false}
                                      hideSelectedOptions={false}
                                      components={{ Option, multiValue }}
                                      onChange={(selected) => this.handleSelectChange(selected, index)}
                                      allowSelectAll={true}
                                      value={facebook.campaignSelected}
                                      className="selectBox"
                                    />
                                    {/* <div className='syncCampagin w-0'>
                                <button className='btn-add' id='exit-screen' onClick={() => this.handleSyncCampaign()}>Save</button>
                              </div> */}
                                  </div>
                                </div> : ""}



                            <div className='btn-manual text-right mt-2'>
                              <button className="btn-remove" onClick={() => this.handleRemoveClick(index, facebook.fbAccountID)} style={{ top: '40px' }} ><i className='mdi mdi-delete'></i></button>

                              {
                                !facebook.campaignToggle ?
                                  <button onClick={() => this.handleResync(facebook, index)} className="btnSync ml-2"><i className='mdi mdi-sync'></i></button>
                                  :
                                  <button className='btn-add ml-2' id='exit-screen' onClick={() => this.handleSyncCampaign(index)}>Save</button>
                              }
                            </div>



                            {/* <button onClick={() => this.handleResync(facebook, index)} className="btnSync"><i className='mdi mdi-sync'></i></button>
                      <button className="btn-remove-io" onClick={() => this.handleRemoveClick(index,facebook.fbAccountID)} style={{ position: "unset" }}><i className='mdi mdi-delete'></i></button> */}
                          </div>
                        </div> :
                        <div className='col-md-12 mb-4 manualCard' key={index}>
                          <h5 className='text-dark'>Facebook Account :</h5>
                          <div>
                            <h5>Infomo Seat</h5>

                          </div>
                          <div className='btn-manual text-right mt-2'>
                            <button className="btn-remove" onClick={() => this.handleRemoveClick(index, facebook.fbAccountID)} style={{ top: '40px' }} ><i className='mdi mdi-delete'></i></button>
                          </div>

                        </div>
                    }




                  </>
              ))}
          </div>
        }

        <div className='addBtn' style={{ textAlign: "right" }}>
          <button className='btn-add-io' title={`${facebookAds.length == 0 ? "" : "If you want to log in to a different Facebook account on the same browser, you will need to log out of the current account first"}`} style={{ marginTop: "0px", float: "none" }} onClick={() => this.handleAddClick()}><i className="mdi mdi-plus-box"></i>
          </button>
        </div>
      </>
    )

  }
}

export default connect(state => ({
  tenantId: get(state, 'app.preSignInState.tenantId', ''),
  userId: get(state, 'app.preSignInData.userId', ''),
}), { getFacebookUserInfoAction, syncAccCampaignAction, facebookSyncCampaignAction, createAdvertiserAction, getFacebookRefetchAction, deleteAccountsAction })(index);